<app-custom-product-item [item]="product" [pdp]="false"></app-custom-product-item>
@if (product.variantOptions) {
  <div class="cx-variant-style-icons">
    <cx-variant-style-icons
      [variants]="product.variantOptions"
    ></cx-variant-style-icons>
  </div>
}
